import React, { useMemo, useState } from "react";
import "./big-event.css";

export default function RecognitionOrders() {
  const events = useMemo(
    () => [
      { id: "bb-slc-2025", name: "Breaking Barriers — Salt Lake City" },
      { id: "naol-aug", name: "New Art of Living — August Tour" },
    ],
    []
  );

  const [eventId, setEventId] = useState(events[0].id);
  const presets = [
    { id: "top-points", name: "Top Points (Production/4x4)" },
    { id: "finished-4x4", name: "4x4 Completed" },
    { id: "associate-powerbuild", name: "Associate Power Build Shirt" },
    { id: "licensing-complete", name: "Licensing Completed" },
  ];

  const runPreset = (presetId) => {
    const preset = presets.find(p => p.id === presetId);
    // TODO: Fetch actual data from trackers and profiles
    alert(`Running: ${preset?.name}\n\nEvent: ${eventId}\n\nThis will:\n1. Query production/tracker data\n2. Apply preset thresholds\n3. Generate recognition list\n4. Ready for export`);
  };

  const handlePreview = () => {
    alert(`Preview Mode\n\nShowing sample recognition data for event: ${eventId}\n\nFinal export will include:\n- Names\n- Achievements\n- Awards/Shirts earned`);
  };

  const handleExportCSV = () => {
    alert(`Exporting CSV\n\nEvent: ${eventId}\n\nFile will include all qualified participants with their recognition details.`);
  };

  const handleExportPDF = () => {
    alert(`Exporting PDF\n\nEvent: ${eventId}\n\nGenerating printable recognition certificates and lists.`);
  };

  const handleConfigure = (presetId) => {
    const preset = presets.find(p => p.id === presetId);
    alert(`Configure: ${preset?.name}\n\nSettings:\n- Score thresholds\n- Qualification period\n- Tie-breaker rules\n- Award types`);
  };

  return (
    <div className="be-wrap">
      <div className="be-header">
        <div>
          <h2 className="be-title">Recognition Orders</h2>
          <p className="be-subtitle">
            Generate automated recognition lists (awards, shirts, milestones).
          </p>
        </div>
      </div>

      <div className="be-card" style={{ padding: 14 }}>
        <div className="grid-2">
          <div className="field">
            <label className="field-label">Event</label>
            <select
              className="input"
              value={eventId}
              onChange={(e) => setEventId(e.target.value)}
            >
              {events.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name}
                </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label className="field-label">
              Output
              <span className="tag-soon">CSV / PDF</span>
            </label>
            <div className="be-row">
              <button className="btn subtle" onClick={handlePreview}>Preview</button>
              <button className="btn subtle" onClick={handleExportCSV}>Export CSV</button>
              <button className="btn subtle" onClick={handleExportPDF}>Export PDF</button>
            </div>
          </div>
        </div>
      </div>

      <div className="be-card">
        <div className="be-header compact" style={{ padding: 14 }}>
          <h3 className="be-title" style={{ fontSize: 16 }}>
            Preset Reports
          </h3>
        </div>

        <div
          style={{
            padding: 14,
            display: "grid",
            gap: 10,
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          }}
        >
          {presets.map((p) => (
            <div
              key={p.id}
              className="kpi-card"
              style={{ display: "grid", gap: 8 }}
            >
              <div className="kpi-label">Preset</div>
              <div className="kpi-value" style={{ fontSize: 16 }}>
                {p.name}
              </div>
              <div className="action-row" style={{ marginTop: 4 }}>
                <button className="gold-button" onClick={() => runPreset(p.id)}>
                  Run
                </button>
                <button className="btn subtle" onClick={() => handleConfigure(p.id)}>Configure</button>
              </div>
            </div>
          ))}
        </div>

        <div className="edit-placeholder">
          <div className="field-label" style={{ marginBottom: 6 }}>
            Custom logic <span className="tag-soon">Soon</span>
          </div>
          <ul className="edit-list muted small">
            <li>Pulls milestones from profiles (e.g., shirt size, rank).</li>
            <li>Merges scores from Production/4x4/Licensing trackers.</li>
            <li>Lets you set thresholds and tie-breakers per preset.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
